import React from 'react'
import Tour_Banner from './tour-banner/Tour_Banner'
import Our_Packages from './our-packages/Our_Packages'

const Tour_Packages = () => {
    return (
        <>
            <Tour_Banner />
            <Our_Packages />
        </>
    )
}

export default Tour_Packages